import { useQueryState } from 'nuqs'
import { useMemo } from 'react'
import {
	ReactLogo,
	SolidLogo,
	SvelteLogo,
	VueLogo,
} from '#app/components/icons/brands'
import { Code02, Download01, Link01 } from '#app/components/icons/duotone'
import { parseAsFormat, type IconFormat } from '#app/utils/search-params'
import { useDefaultFormat } from '#app/utils/use-icon-set-search'
import { Select } from './shared/select/select'

export function CustomizeFormat() {
	const defaultFormat = useDefaultFormat()
	const formatParser = useMemo(
		() => parseAsFormat.withDefault(defaultFormat),
		[defaultFormat],
	)
	const [format, setFormat] = useQueryState('format', formatParser)

	return (
		<div className="flex items-center justify-between gap-2">
			<h2 className="text-primary text-sm font-semibold">Mode</h2>

			<Select
				size="md"
				aria-label="Copy format"
				selectedKey={format}
				onSelectionChange={(key) => setFormat(key as IconFormat)}
			>
				<Select.Item id="notion" icon={Link01}>
					Copy Notion Link
				</Select.Item>
				<Select.Item id="download-svg" icon={Download01}>
					Download SVG
				</Select.Item>
				<Select.Item id="copy-svg" icon={Code02}>
					Copy SVG
				</Select.Item>
				<Select.Item id="copy-react" icon={ReactLogo}>
					Copy React
				</Select.Item>
				<Select.Item id="copy-vue" icon={VueLogo}>
					Copy Vue
				</Select.Item>
				<Select.Item id="copy-svelte" icon={SvelteLogo}>
					Copy Svelte
				</Select.Item>
				<Select.Item id="copy-solid" icon={SolidLogo}>
					Copy Solid
				</Select.Item>
			</Select>
		</div>
	)
}
